import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, Grid, Stack, TextField, Toolbar, Tooltip, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import CustomDatePicker from "../utilities/CustomDatePicker";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import AgGridTable from "../utilities/AgGridTable";
import FormPageHeader from "../utilities/FormPageHeader";
import { useNavigate } from "react-router-dom";

const BankPayment = (props) => {
    const navigate = useNavigate();
    const dummyRowData = [
        {account:"25100-1-1	NOLTE KUECHEN NK",debit:"150,000.00",credit:"",currency:" 150,000.00",exchangeRate:"1.0000 ",hcurrDR:" 150,000.00",hcurrCR:"",lineDescription:"AMOUNT TRANSFERRED TO NOLTE KUCHEN"},
        {account:"25100-1-1	NOLTE KUECHEN NK",debit:"",credit:"150,000.00",currency:" 150,000.00",exchangeRate:"1.0000 ",hcurrDR:" 150,000.00",hcurrCR:"",lineDescription:"AMOUNT TRANSFERRED TO NOLTE KUCHEN"}
    ]
    const acllocationRowData = [
        {ab_no : "3618638 02 " ,due_date : "14.05.23" ,amount : " 15,000.00" ,paid : "-" ,Balance : " 15,000.00 " ,Allocated:" 15,000.00"},
        {ab_no : "3618638 02 " ,due_date : "14.05.23" ,amount : " 12,500.00 " ,paid : "-" ,Balance : " 12,500.00" ,Allocated:" 12,500.00"},
    ] 
    const gridRef = useRef()
    const [error, setError] = useState()
    const [successMsg, setSuccessMsg] = useState();
    const [snackState, setSnackState] = useState(false);
    const [rowData, setRowData] = useState(dummyRowData)
    const [allocationRowData, setAllocationRowData] = useState(acllocationRowData)
    const [columnDefs, setColumnDefs] = useState([
        { field: 'account', headerName: 'ACCOUNT', },
        { field: 'debit', headerName: 'DEBIT' },
        { field: 'credit', headerName: 'CREDIT' },
        { field: 'currency', headerName: 'Curr.', editable: false },
        { field: 'exchangeRate', headerName: 'Ex Rate', editable: false },
        { field: 'hcurrDR', headerName: 'H. Debit', editable: false },
        { field: 'hcurrCR', headerName: 'H. Credit', editable: false },
        { field: 'lineDescription', headerName: 'LINE DESCRIPTION' },
    ])
    const [allocationColumnDefs, setAllocationColumnDefs] = useState([
        { field: 'ab_no', headerName: 'AB No', },
        { field: 'due_date', eaderName: 'Due Date', },
        { field: 'amount', headerName: 'Amount', },
        { field: 'paid', headerName: 'Paid', },
        { field: 'Balance', headerName: 'Balance', },
        { field: 'Allocated', headerName: 'Allocated', },
    ])

    const handleCancel = () => {
        navigate('/reconciliation')
    }

    const handleSubmit = () => {

    }
    const onGridReady = () => {
    }
    return (
        <>
            <FormPageHeader
                currentPage={"Bank Payment"}
                handleSubmit={handleSubmit}//
                componentName={"Voucher"}
                handleCancel={handleCancel}
                error={error}
                successMsg={successMsg}
                snackState={snackState}
            />
            <Box className="m-10" sx={{ p: 2, border: '1px dashed grey' }}>
                <div>
                    <Grid container spacing={2}>
                        <Grid item xs={2.4}>
                            <Stack>
                                <label className=" basis-0 float-left">Payment Type</label>
                                {/* <FormControl sx={{ width: 200 }} > */}
                                <Select
                                    name="payment_Type"
                                    // value={(currencyOptions.length > 0 && voucherData.currency) && currencyOptions.filter((data) => data.value === voucherData.currency)}
                                    // error={validError.currency ? true : false}
                                    // onChange={handleChangeCurrency}
                                    // isDisabled={params.viewid ? true : false}
                                    //options={currencyOptions}
                                    styles={customStyles()}
                                >
                                </Select>
                                {/* </FormControl> */}
                                {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !voucherData.currency) ? "This field is required" : validError.currency}</Typography> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={2.4}>
                            <Stack>
                                <label className="basis-0 float-left">Doc Date</label>
                                <CustomDatePicker
                                    className="w-[100%]"
                                    format={'dd-MM-yyyy'}
                                    name={'docdate'}
                                    // value={voucherData.docDate}
                                    // handleChange={handleDateChange}
                                    // error={validError.docdate ? true : false}
                                    // disabled={params.viewid ? true : false}
                                    renderInput={(params) => (
                                        <TextField
                                            size="small"
                                            InputLabelProps={{}}
                                            {...params}
                                            sx={{
                                                backgroundColor: props.viewData && '#8080800f'
                                            }}
                                            InputProps={{
                                                readOnly: params.viewid ? true : false,
                                            }}
                                        />
                                    )}
                                />
                                {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !voucherData.docDate) ? "This field is required" : validError.docdate}</Typography> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={2.4}>
                            <Stack>
                                <label className=" basis-0 float-left">Voucher Currency</label>
                                {/* <FormControl sx={{ width: 200 }} > */}
                                <Select
                                    name="vouchertype"
                                    // value={(currencyOptions.length > 0 && voucherData.currency) && currencyOptions.filter((data) => data.value === voucherData.currency)}
                                    // error={validError.currency ? true : false}
                                    // onChange={handleChangeCurrency}
                                    // isDisabled={params.viewid ? true : false}
                                    //options={currencyOptions}
                                    styles={customStyles()}
                                >
                                </Select>
                                {/* </FormControl> */}
                                {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !voucherData.currency) ? "This field is required" : validError.currency}</Typography> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={2.4}>
                            <Stack>
                                <label className="basis-0 float-left">Euro Rate</label>
                                <TextField
                                    className="w-[100%]"
                                    name='eurorate'
                                //error={validError.euroRate ? true : false}
                                // onChange={(params) => { handleEuroChange(params); setValidError({ ...validError, euroRate: checkNumber(event.target.value) }) }}
                                //value={voucherData.euroRate}
                                // helperText={validError.euroRate}
                                // disabled={params.viewid ? true : (voucherData.currency === 'USD' || voucherData.currency === 'OTHER' || (voucherData.currency === 'AED' && !AEDEuroRate)) ? false : true}
                                // style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={2.4}>
                            <Stack>
                                <label className="basis-0 float-left">Posting Date</label>
                                <TextField
                                    name={'postdate'}
                                    // value={moment(voucherData.postDate && (params.id || params.viewid) ? voucherData.postDate : new Date(), 'YYYY-MM-DD').format('DD-MM-YYYY')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                />
                            </Stack>
                        </Grid>

                    </Grid>
                </div>
                <div>
                    <Grid container spacing={2} className="mt-8">
                        <Grid item xs={4}>
                            <Stack>
                                <label className="basis-0 float-left">Vendor</label>
                                <Select
                                    name='vendor'
                                    //value={(voucherData.companyCode && companyOptions) && companyOptions.filter((data) => Number(data.value) === Number(voucherData.companyCode))}
                                    // onChange={handleCompanyChange}
                                    // isDisabled={params.viewid ? true : false}
                                    //options={companyOptions}
                                    styles={customStyles()}
                                />
                            </Stack>
                        </Grid>

                        <Grid item xs={4}>
                            <Stack>
                                <label className="basis-0 float-left">Name</label>
                                <TextField
                                    className="w-[100%]"
                                    name='name'
                                // value={voucherData.invoiceNo}
                                // error={validError?.invoiceNo ? true : false}
                                // onChange={(params) => { handleinvoiceNoChange(params); setValidError({ ...validError, invoiceNo: checkNumber(params.target.value) }) }}
                                // helperText={validError?.invoiceNo}

                                />

                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <Stack>
                                <label className="basis-0 float-left">Doc Description</label>
                                <TextField
                                    // className="w-[30%]"
                                    name='docdescription'
                                //value={voucherData.docDescription}
                                //error={validError.docDescription ? true : false}
                                //helperText={validError.docDescription}
                                // onChange={(params) => { handleDocDescriptionChange(params); setValidError({ ...validError, docDescription: checkSpecialChar(params.target.value) }) }}

                                />
                            </Stack>
                        </Grid>

                    </Grid>

                </div>
                <div>
                    <Grid container spacing={2} className="mt-8">
                        <Grid item xs={2.4}>
                            <Stack>
                                <label className=" basis-0 float-left">Bank</label>
                                {/* <FormControl sx={{ width: 200 }} > */}
                                <Select
                                    name="bank"
                                    // value={(currencyOptions.length > 0 && voucherData.currency) && currencyOptions.filter((data) => data.value === voucherData.currency)}
                                    // error={validError.currency ? true : false}
                                    // onChange={handleChangeCurrency}
                                    // isDisabled={params.viewid ? true : false}
                                    //options={currencyOptions}
                                    styles={customStyles()}
                                >
                                </Select>
                                {/* </FormControl> */}
                                {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !voucherData.currency) ? "This field is required" : validError.currency}</Typography> */}
                            </Stack>
                        </Grid>
                        <Grid item xs={2.4}>
                            <Stack>
                                <label className="basis-0 float-left">Euro Rate</label>
                                <TextField
                                    className="w-[100%]"
                                    name='eurorate'
                                //error={validError.euroRate ? true : false}
                                // onChange={(params) => { handleEuroChange(params); setValidError({ ...validError, euroRate: checkNumber(event.target.value) }) }}
                                //value={voucherData.euroRate}
                                // helperText={validError.euroRate}
                                // disabled={params.viewid ? true : (voucherData.currency === 'USD' || voucherData.currency === 'OTHER' || (voucherData.currency === 'AED' && !AEDEuroRate)) ? false : true}
                                // style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={2.4}>
                            <Stack>
                                <label className="basis-0 float-left">Chq NO</label>
                                <TextField
                                    className="w-[100%]"
                                    name='eurorate'
                                //error={validError.euroRate ? true : false}
                                // onChange={(params) => { handleEuroChange(params); setValidError({ ...validError, euroRate: checkNumber(event.target.value) }) }}
                                //value={voucherData.euroRate}
                                // helperText={validError.euroRate}
                                // disabled={params.viewid ? true : (voucherData.currency === 'USD' || voucherData.currency === 'OTHER' || (voucherData.currency === 'AED' && !AEDEuroRate)) ? false : true}
                                // style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={2.4}>
                            <Stack>
                                <label className="basis-0 float-left">Amount</label>
                                <TextField
                                    className="w-[100%]"
                                    name='eurorate'
                                //error={validError.euroRate ? true : false}
                                // onChange={(params) => { handleEuroChange(params); setValidError({ ...validError, euroRate: checkNumber(event.target.value) }) }}
                                //value={voucherData.euroRate}
                                // helperText={validError.euroRate}
                                // disabled={params.viewid ? true : (voucherData.currency === 'USD' || voucherData.currency === 'OTHER' || (voucherData.currency === 'AED' && !AEDEuroRate)) ? false : true}
                                // style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={2.4}>
                            <Stack>
                                <label className="basis-0 float-left">Curr</label>
                                <TextField
                                    name={'postdate'}
                                    // value={moment(voucherData.postDate && (params.id || params.viewid) ? voucherData.postDate : new Date(), 'YYYY-MM-DD').format('DD-MM-YYYY')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                />
                            </Stack>
                        </Grid>

                    </Grid>

                    {/* <Grid container spacing={2} className="mt-5">
                        <Grid item xs={6} >
                            <Stack>
                                <label className="basis-0 float-left">Doc Description</label>
                                <TextField
                                    // className="w-[30%]"
                                    name='docdescription'
                                //value={voucherData.docDescription}
                                //error={validError.docDescription ? true : false}
                                //helperText={validError.docDescription}
                                // onChange={(params) => { handleDocDescriptionChange(params); setValidError({ ...validError, docDescription: checkSpecialChar(params.target.value) }) }}

                                />
                            </Stack>
                        </Grid>

                    </Grid> */}
                </div>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={7}>
                    <div className="mt-20" style={{ height: '300px' }}>
                        <AgGridTable
                            rowData={rowData}
                            columnDefs={columnDefs}
                            onGridReady={onGridReady}
                            rowGroupPanelShow='never'
                            gridRef={gridRef}
                            //  onSelectionChanged={onSelectionChanged}
                            // onCellValueChanged={onCellValueChanged}
                            //  getContextMenuItems={getContextMenuItems}
                            floatingFilter={false}
                        />
                        <Box className="p-8 m-8" sx={{ pb: 1, border: '1px dashed grey' }}>
                            <Grid container spacing={2} className="justify-center mt-1" >
                                <Grid item xs={2}>
                                    <label className="basis-0 float-left">Total Debits :</label>
                                    <TextField
                                        className="w-[100%]"
                                        name='totalDebits'
                                        value={"150,000.00"}
                                        // value={totalDebits}
                                        size="small"
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={2}>
                                    <label className="basis-0 float-left">Total Credits :</label>
                                    <TextField
                                        className="w-[100%]"
                                        name='totalCredits'
                                        value={"150,000.00"}
                                        //value={totalCredits}
                                        size="small"
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={2}>
                                    <label className=" basis-0 float-left">Diff :</label>
                                    <TextField
                                        className="w-[100%]"
                                        name='eurorate'
                                        size="small"
                                        value={0}
                                        //value={totalDebits - totalCredits}
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={2} className="mt-20">
                                    <TextField
                                        className="w-[100%]"
                                        name='AED'
                                        value={"150,000.00"}
                                        // value={voucherData.currency}
                                        size="small"
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={2} className="mt-20">
                                    <TextField
                                        className="w-[100%]"
                                        name='rate'
                                        value={1}
                                        //value={voucherData.euroRate}
                                        size="small"
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} className="justify-center mt-5" >
                                <Grid item xs={2}>
                                    <TextField
                                        className="w-[100%]"
                                        name='convertedDebits'
                                        size="small"
                                        value={"150,000.00"}
                                        //value={voucherData.euroRate === 0 ? 0 : Number(totalDebits / voucherData.euroRate).toFixed(2)}
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField
                                        className="w-[100%]"
                                        name='convertedCredits'
                                        size="small"
                                        value={"150,000.00"}
                                        //value={voucherData.euroRate === 0 ? 0 : Number(totalCredits / voucherData.euroRate).toFixed(2)}
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField
                                        className="w-[100%]"
                                        name='diff'
                                        size="small"
                                        value={0}
                                        // value={voucherData.euroRate === 0 ? 0 : Number(totalDebits / voucherData.euroRate).toFixed(2) - Number(totalCredits / voucherData.euroRate).toFixed(2)}
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={2}>
                                    <TextField
                                        className="w-[100%]"
                                        name='EUR'
                                        value="EUR"
                                        size="small"
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={2} >

                                </Grid>
                            </Grid>
                        </Box>
                    </div>
                </Grid>
                <Grid item xs={5}>
                    <div className="mt-20" style={{ height: '300px' }}>
                        <AgGridTable
                            rowData={allocationRowData}
                            columnDefs={allocationColumnDefs}
                            onGridReady={onGridReady}
                            rowGroupPanelShow='never'
                            gridRef={gridRef}
                            //  onSelectionChanged={onSelectionChanged}
                            // onCellValueChanged={onCellValueChanged}
                            //  getContextMenuItems={getContextMenuItems}
                            floatingFilter={false}
                        />
                        <Box className="p-8 m-8 " sx={{ pb: 1, border: '1px dashed grey' }}>
                            <Grid container spacing={2} className="justify-center mt-1" >
                                <Grid item xs={4} >
                                    <Stack>
                                        <label className="basis-0 float-left">Amount To Be Allocated</label>
                                        <TextField
                                            className="w-[100%]"
                                            name='amount'
                                            value={"150,000.00"}
                                            size="small"
                                            InputProps={{
                                                readOnly: true
                                            }}

                                        />
                                    </Stack>
                                </Grid>

                                <Grid item xs={4}>
                                    <Stack>
                                        <label className="basis-0 float-left">Allocated</label>
                                        <TextField
                                            className="w-[100%]"
                                            name='allocated'
                                            value={"150,000.00"}
                                            size="small"
                                            InputProps={{
                                                readOnly: true
                                            }}

                                        />
                                    </Stack>
                                </Grid>

                                <Grid item xs={4}>
                                    <Stack>
                                        <label className="basis-0 float-left">Balace</label>
                                        <TextField
                                            className="w-[100%]"
                                            name='balance'
                                            value={"-"}
                                            size="small"
                                            InputProps={{
                                                readOnly: true
                                            }}

                                        />
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Box>
                    </div>
                </Grid>
            </Grid>
            {/* </DialogContent>
                <DialogActions> */}

            {/* </DialogActions>
            </Dialog> */}
        </>
    )

}
export default BankPayment